import { useContext } from "react";
import { AppContext } from "../App";
import { STR_ACCOUNT, STR_MENU_INQUIRIES, STR_MENU_SCAN } from "../Strings";
import { LiaUserSolid } from "react-icons/lia";
import { LuClipboardList } from "react-icons/lu";
import { GrMapLocation } from "react-icons/gr";

export default function BottomBar() {
  const appContext = useContext(AppContext);

  return (
    <div className="BottomBar">
      <div className="barInner">

        <div
          className="mIcon"
          data-active={appContext.navItem === 'scan' || !appContext.navItem}
          onClick={() => appContext.navTo({ item: 'scan' })}
        >
          <GrMapLocation className="mSymbol" />
          <div className="mText">{STR_MENU_SCAN[appContext.language]}</div>
        </div>

        <div
          className="mIcon"
          data-active={appContext.navItem === 'inquiries'}
          onClick={() => appContext.navTo({ item: 'inquiries' })}
        >
          <LuClipboardList className="mSymbol" />
          <div className="mText">{STR_MENU_INQUIRIES[appContext.language]}</div>
        </div>

        <div
          className="mIcon"
          data-active={appContext.navItem === 'account'}
          onClick={() => appContext.navTo({ item: 'account' })}
        >
          <LiaUserSolid className="mSymbol" />
          <div className="mText">{STR_ACCOUNT[appContext.language]}</div>
        </div>

      </div>
    </div>
  );
}
